module.exports = __webpack_public_path__ + "images/backgrounds/mountain/medium.c442799d6e1eb35bca84.jpg";